import { useTranslation } from 'react-i18next';
import BuildingStructureFirstPart from './BuildingStructure/BuildingStructureFirstPart';
import BuildingStructureLastPart from './BuildingStructure/BuildingStructureLastPart';
import { UseFormReturn } from 'react-hook-form';
import { MaterialsToComplete } from '../ProjectSimulator';
import { ListValueProps } from '../utils';

type BuildingStructureProps = {
  buildingStructure: BuildingStructureData;
  frameworkMaterials: MaterialsToComplete[];
  wallTypeMaterials: MaterialsToComplete[];
  ceilingMaterials: MaterialsToComplete[];
  floorMaterials: MaterialsToComplete[];
  form: UseFormReturn;
};

export type BuildingStructureData = {
  ceiling: {
    fixed: number;
    removable: number;
  };
  floor: {
    fake: boolean;
    hardFloor: number;
    softFloor: number;
  };
  framework: {
    wood: number;
    concrete: number;
    steel: number;
  };
  foundationType: {
    value: number;
    list: {
      TRADITIONNAL: ListValueProps;
    };
  };
  roofMaterial: {
    value: number;
    list: {
      METAL: ListValueProps;
    };
  };
  slab: {
    list: ListValueProps[];
    value: number;
  };
  wallType: {
    separative: number;
    distributive: number;
  };
  elevators: number;
  stairs: number;
  reinforcedConcreteStructure: boolean;
};

function BuildingStructure({
  buildingStructure,
  frameworkMaterials,
  wallTypeMaterials,
  ceilingMaterials,
  floorMaterials,
  form,
}: BuildingStructureProps) {
  const { t } = useTranslation();
  return (
    <div className="form-block">
      <h2 className="form-title">
        {t('APP.PROJECT.SIMULATOR.ADVANCED_CONCEPTION.BUILDING.STRUCTURE.TITLE', {
          defaultValue: 'Structure du batiment',
        })}
      </h2>

      <hr className="line-title-separation" />

      <div style={{ display: 'flex' }}>
        <BuildingStructureFirstPart
          buildingStructure={buildingStructure}
          frameworkMaterials={frameworkMaterials}
          form={form}
        />
        <BuildingStructureLastPart
          buildingStructure={buildingStructure}
          wallTypeMaterials={wallTypeMaterials}
          ceilingMaterials={ceilingMaterials}
          floorMaterials={floorMaterials}
          form={form}
        />
      </div>
    </div>
  );
}

export default BuildingStructure;
